<template>
  <main>
    <section-hero :bgImg="bgImg" :subtitle="subtitle"></section-hero>
    <section class="section--user-status" id="scrollToOnLoad">
      <b-container class="container--wide">
        <div class="user">
          <b-row class="flex-column flex-sm-row">
            <b-col cols="6" sm="4" offset="3" offset-sm="1"
              class="d-flex justify-content-between align-items-center">
                <img class="img-fluid user__img" src="@/assets/ico-person.svg" alt="">
            </b-col>
            <b-col sm="6" class="mt-5 mt-xl-3 text-center text-sm-left">
              <h1 class="text--black text--spacing">Reset Password</h1>
               <b-form id="loginForm" @submit.prevent="resetPassword">
                <b-form-input
                  type="email"
                  :value="reset.email"
                  disabled
                  aria-describedby="inputLiveFeedback"
                  class="mb-3">
                </b-form-input>
                <b-form-input
                  v-model="reset.password"
                  :state="error ? false : null"
                  type="password"
                  required placeholder="Enter password"
                  aria-describedby="inputLiveFeedback"
                  class="mb-3">
                </b-form-input>
                <b-form-input
                  v-model="reset.password_confirmation"
                  type="password"
                  :state="error ? false : null"
                  required placeholder="Enter password confirmation"
                  aria-describedby="inputLiveFeedback"
                  class="mb-3">
                </b-form-input>
                <b-form-invalid-feedback id="inputLiveFeedback">
                  {{ error }}
                </b-form-invalid-feedback>
                <b-btn variant="primary" size="sm" type="submit">
                  Reset Password
                </b-btn>
              </b-form>
            </b-col>
          </b-row>
        </div>
      </b-container>
    </section>
    <section-support></section-support>
  </main>
</template>

<script>
import auth from '@/api/v1/auth';
import Hero from '@/components/Hero';
import Support from '@/components/Support/Index';

export default {
  components: {
    'section-hero': Hero,
    'section-support': Support,
  },
  data() {
    return {
      bgImg: 'Banner5-My_Account-',
      subtitle: this.$t('nav.myAccount'),
      userType: null,
      reset: {},
      error: '',
    };
  },
  methods: {
    getParams() {
      this.reset.email = this.$route.query.email;
      this.reset.password_token = this.$route.query.token;
    },
    resetPassword() {
      if (this.reset.password === this.reset.password_confirmation) {
        // const err = (error) => {
        //   if (error.response) {
        //     this.error = error.response.data.errors;
        //   }
        // };
        auth.resetPassword(this.reset);
      } else {
        this.error = 'Confirm your password ';
        this.reset.password_confirmation = '';
      }
    },
  },
  created() {
    this.getParams();
  },
  mounted() {
    this.$scrollTo('#scrollToOnLoad');
  },
};
</script>

<style lang="scss" scoped>
@import "./src/styles/helpers/_variables.scss";
@import "./src/styles/helpers/_include-media.scss";

.section--user-status {
  padding: 100px 0 110px;
  @include media("<md") {
    padding: 40px 0;
  }
}
.user {
  background-color: #e4e4e4;
  padding: 135px 0 100px;
  @include media("<lg") {
    padding: 50px 0;
  }
  @include media("<md") {
    padding: 50px 30px;
  }
  &__text {
    color: $color--black;
    font-size: 28px;
    @include media("<md") {
      font-size: 16px;
    }
    @include media("<sm") {
      font-size: 14px;
    }
  }
  &__img {
    width: 300px;
  }
  @include media('<lg') {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Auth/ForgotPassword.vue